import React from 'react';
import { withRouter } from 'react-router-dom';
import Grid2 from './Grid2.jsx';

class FluxoEstoque extends React.Component {

    constructor() {

        super();

        this.state = {
            gridHeader: [
                "Produto",
                "Conteúdo",
                "Unidades Disponíveis",
                "Data",
                "Fluxo",
                "Usuário" ],
            fluxo_estoque: [],
            centroId: 0,
            centro: ""
        };

        this.voltar = this.voltar.bind(this);

    }

    voltar() {

        let obj = {
            row: {
                id: this.state.centroId,
                data: [ this.state.centro ]
            }
        };

        this.props.history.push({
            pathname: "/estoquecentro",
            state: obj
        });

    }

    componentDidMount() {

        if (localStorage.roleEstoque === "nenhuma") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/estoque";
        }

        let cId = this.props.location.state.centroId;
        let centroNome = this.props.location.state.centro;
        this.setState({ centroId: cId });
        this.setState({ centro: centroNome });

        fetch("/api/fluxo_estoque/centro/grid/" + cId, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ fluxo_estoque: responseJson });

        });

    }

    render() {
        return(
            <div>
                <h1 id="fluxo-estoque-title">Fluxo de Estoque</h1><br />
                <p id="fluxo-estoque-centro">
                    <b>Centro: </b> { this.state.centro }
                </p><br /><br />
                <Grid2 key={ this.state.fluxo_estoque }
                    header={ this.state.gridHeader }
                    data={ this.state.fluxo_estoque }
                    pageSize={ 10 }
                    gridWidth={ "800px" } />
                <br />
                <button id="fluxo-estoque-voltar-btn" onClick={ this.voltar }>
                    Voltar
                </button><br /><br />
            </div>
        );
    }

}

export default withRouter(FluxoEstoque);

